import type { InjectionKey, Ref } from 'vue'
import type { Stakeholder } from '../Stakeholder'
import type { GetStakeholderStatsRequestResponse } from '../api-requests/StakeholdersRequests'

/**
 * App-wide stakeholder statistics (counts + recently added/updated lists),
 * provided once near the stakeholders section root and kept fresh via
 * SignalR. `addAddedStakeholder` / `addUpdatedStakeholder` apply optimistic
 * local updates after a create/edit so the dashboard reacts immediately.
 */
export interface StakeholderStatsService {
  stats: Ref<GetStakeholderStatsRequestResponse['stats']>
  isFetchingStats: Ref<boolean>
  fetchStats(): Promise<void>
  addUpdatedStakeholder(stakeholder: Stakeholder): void
  addAddedStakeholder(stakeholder: Stakeholder): void
}

export const stakeholderStatsKey = Symbol(
  'gs-stakeholder-stats'
) as InjectionKey<StakeholderStatsService>
